import type { ReactNode } from "react";

/**
 * Break-glass. RedocStandalone renders and scrolls a whole documentation site,
 * so it has to escape the app's page flow entirely — pinned to the viewport
 * with its own scroll container. ui-core has no layout for "take over the
 * screen", and it shouldn't: every other screen wants the opposite.
 */
export function ApiAccessFullViewportPane({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="absolute inset-0 flex scroll-p-0 flex-col overflow-y-scroll scroll-smooth">
      {children}
    </div>
  );
}
